import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Initializes and controls the full-screen intro page preloader.
 * Temporarily disables Lenis smooth scroll, slides the loader out to reveal the homepage,
 * and coordinates the curtain reveal sequence.
 */
const initLoader = () => {
  const loader = document.getElementById('page-loader');
  if (!loader) return;

  // 1. Temporarily disable scrolling during the intro animation
  document.documentElement.classList.add('overflow-hidden');
  document.body.classList.add('overflow-hidden');

  if (window.lenis) {
    window.lenis.stop();
  }

  // 2. Setup GSAP timeline for loader animation
  const tl = gsap.timeline({
    onComplete: () => {
      // Re-enable page scrolling
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');

      if (window.lenis) {
        window.lenis.start();
      }

      // Hide loader element
      loader.style.display = 'none';

      // Refresh ScrollTrigger
      ScrollTrigger.refresh();
    }
  });

  // 3. Slide out the loader overlay (upwards) to reveal homepage
  tl.to(
    loader,
    {
      yPercent: -100,
      opacity: 0,
      duration: 0.85,
      ease: 'power3.inOut',
      delay: 0.2 // Brief splash screen delay
    }
  );

  // 4. Staggered curtain reveal (only hero columns slide upwards on load)
  const curtainCols = document.querySelectorAll('.hero-video-banner .image-reveal__col');
  if (curtainCols.length > 0) {
    tl.to(
      curtainCols,
      {
        yPercent: -100,
        duration: 1.1,
        ease: 'power3.inOut'
      },
      '-=0.5'
    );
  }

  // 5. Animate hero elements in sequence (logo and CTA reveal staggered together)
  const heroElements = document.querySelectorAll('.custom-navbar .navbar-brand-centered, .custom-navbar .navbar-cta-btn');
  if (heroElements.length > 0) {
    tl.fromTo(
      heroElements,
      {
        opacity: 0,
        y: 30
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.15,
        ease: 'power3.out'
      },
      '-=0.7'
    );
  }
};

export default initLoader;
